"use client";

// src/label.tsx
import { cn } from "@momo/utils";
import * as LabelPrimitive from "@radix-ui/react-label";
import { cva } from "class-variance-authority";
import { jsx } from "react/jsx-runtime";
var labelVariants = cva([
  "text-sm font-medium leading-none",
  "peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
]);
var Label = (props) => {
  const { className, ...rest } = props;
  return /* @__PURE__ */ jsx(LabelPrimitive.Root, { className: cn(labelVariants(), className), ...rest });
};

export {
  labelVariants,
  Label
};
